import { twoDecimals } from "../../../shared/utility";

const outsideBrokersFormPDF = props => {
    const { tableData } = props;
    const hasBrokers = Array.isArray(tableData) && tableData.length > 0;
    const payNotice = hasBrokers
        ? `<div style="color:#da2229;font-weight:bold;font-size:14px;margin-bottom:6px;">Pay Outside Broker</div>`
        : '';
    return `${payNotice}<div class="the-table">
            <table>
                <tbody>
                    <tr>
                        <td class="col-40"><strong>${props.name ? props.name : ''} Outside Broker Name</strong></td>
                        <td class="col-30"><strong>Percentage</strong></td>
                        <td class="col-30"><strong>Value</strong></td>
                    </tr>
                    ${tableData.map((l,i) => {
                        let percentage = '';
                        let value = '';
                        if (l.percentage !== 'N/A') {
                            percentage = twoDecimals(l.percentage * 100) + ' %';
                            value = `$${twoDecimals(l.value)}`;
                        } else {
                            percentage = 'N/A';
                            value = `$${twoDecimals(l.value)}`;
                        }
                        return `<tr>
                            <td class="col-40">${l.name}</td>
                            <td class="col-30">${percentage}</td>
                            <td class="col-30">${value}</td>
                        </tr>`
                    }).join('')}
                </tbody>
            </table>
        </div>`;
}
export default outsideBrokersFormPDF;

export const referralsFormPDF = props => {
    const { tableData } = props;
    return `<div class="the-table">
            <table>
                <tbody>
                    <tr>
                        <td class="col-40"><strong>${props.name ? props.name : ''} Referral Name</strong></td>
                        <td class="col-30"><strong>Percentage</strong></td>
                        <td class="col-30"><strong>Value</strong></td>
                    </tr>
                    ${tableData.map((l,i) => {
                        let percentage = '';
                        let value = '';
                        if (l.percentage !== 'N/A') {
                            percentage = twoDecimals(l.percentage * 100) + ' %';
                            value = `$${twoDecimals(l.value)}`;
                        } else {
                            percentage = 'N/A';
                            value = `$${twoDecimals(l.value)}`;
                        }
                        return `<tr>
                            <td class="col-40">${l.name}</td>
                            <td class="col-30">${percentage}</td>
                            <td class="col-30">${value}</td>
                        </tr>`
                    }).join('')}
                </tbody>
            </table>
        </div>`
}
